import { h, render } from 'vue';
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';

export function useConfirm() {
  // Create a confirm function that returns a promise with a boolean result
  const confirm = async (options = {}) => {
    return new Promise((resolve) => {
      // Create a div to mount our modal
      const modalContainer = document.createElement('div');
      document.body.appendChild(modalContainer);

      // Function to unmount and clean up the modal
      const unmount = () => {
        render(null, modalContainer);
        document.body.removeChild(modalContainer);
      };

      // Create the modal with our options and handlers
      const modalInstance = h(ConfirmModal, {
        ...options,
        show: true,
        onConfirm: () => {
          unmount();
          resolve(true);
        },
        onCancel: () => {
          unmount();
          resolve(false);
        }
      });

      // Render the modal
      render(modalInstance, modalContainer);
    });
  };

  // Return the confirm function
  return { confirm };
}

// Convenience export for direct use with capital C to avoid conflicts with window.confirm
export default async function Confirm(options = {}) {
  const { confirm: confirmFn } = useConfirm();
  return await confirmFn(options);
}